'use strict';

angular.module('app', [
    'mgcrea.ngStrap',
    'ipCookie',
    'ui.router',
    'ui.bootstrap',
    'ui.bootstrap.tpls',
    'angularFileUpload',
    'AngularPrint',
    'LocalStorageModule',
    'ngSanitize',
    'ngMessages',
    'angular-click-outside',

    'app.authentication',
    'app.timeline',
    'app.home',
    'app.newInfluencers',
    'app.influencersPending',
    'app.influencers',
    'app.influencerDetail',
    'app.addNewInfluencer',
    'app.mergeInfluencer',
    'app.newInfluencerDetail',
    'app.influencerManagementLog',
    'app.influencerManagementLogDetailed',
    'app.interestingCountry',
    'app.measure',
    'app.discover',
    'app.profile',
    'app.profileInfluencer',
    'app.notification',
    'app.notificationLogin',
    'app.notificationScreenshot',
    'app.notificationDiscoverCondition',
    'app.resetPassword',

    'app.influencerGroup',
    'app.addNewInfluencerGroup',
    'app.detailInfluencerGroup',
    'app.addInfluencerToInfluencerGroup',
    'app.influencerGroupInfluencerList',
    'app.influencerGroupCondition',

    'app.userAndBillingOverview',
    'app.accountDetails',
    'app.createAccount',
    'app.subscriptionAndBilling',
    'app.setPaidSubscription',
    'app.deleteAccount',
    'app.accountProjects',
    'app.advertisersManagement',
    'app.addAdvertiserToAgency',
    'app.deleteAdvertiserFromAgency',

    'app.userManagement',
    'app.editUserProfile',
    'app.userAccountAction',
    'app.addUserToAccount',

    'app.performanceReportTimeline',
    'app.performanceReportKPI',
    'app.performanceReportLocalAreas',
    'app.performanceReportMentionTimeline',
    'app.bestPerformingInfluencersReport',
    'app.performanceReturnOnInvestmentReport',
    'app.ReturnOnInvestmentSetting',
    'app.performanceReportTierPerformance',
    'app.performanceInteractionReport',

    'app.exposureReportKPI',
    'app.exposureReportPlatform',
    'app.exposureReportBestExposure',

    'app.segmentationReportInfluencerOverview',
    'app.segmentationReportSegment',
    'app.segmentationReportIndustry',

    'app.insightReportOpportunity',
    'app.insightReportBenchmark',

    'app.rankingScoreReportInformation',
    'app.rankingScoreReportTopic',
    'app.rankingScoreReportExposure',

    'app.createCustomReport',
    'app.detailCustomReport',
    'app.deleteCustomReport',
    'app.editCustomReport',
    'app.saveAsCustomReport',

    'app.instagramPostOverview',
    'app.admin',
    'app.newMentions',
    'app.addNewMention',
    'app.mentions',
    'app.mentionDetail',
    'app.deleteMention',
    'app.addNewTranslation',
    'app.translations',
    'app.mentionManagementLog',
    'app.mentionManagementLogDetailed',
    'app.mention',

    'app.duplicationFactors',
    'app.updateDuplicationFactors',

    'app.referencePoints',
    'app.updateReferencePoints',

    'app.commonPages',
    'app.addNewCommonPage',
    'app.commonPageDetail',
    'app.deleteCommonPage',

    'app.manualPosts',
    'app.reCrawlPosts',
    'app.campaignOverview',

    'app.engagementScores',
    'app.updateEngagementScores',

    'app.networks',
    'app.addNewNetwork',
    'app.networkDetail',
    'app.deleteNetwork',
    'app.revertNetwork',

    'app.filter',
    'app.directive',
    'app.newMention',
    'app.constants',

    'app.advertiserDropdownList',
    'app.advertiserProjectList',
    'app.advertiserProjectDetail',
    'app.advertiserPreferredList',
    'app.advertiserPerferredDetail',
    'app.influencerChannelList',
    'app.networkInfluencerList',
    'app.advertiserInfluencerGroup',
    'app.advertiserCampaignList',

    'app.blogPostOverview',
    'app.influencerOverview',
    'app.youtubePostOverview',

    'app.influencerManageChannels',
    'app.networkManageInfluencers',

    'app.systemLog',
    'app.print.header',
    'app.customReport',
    'app.topicSettingReportSegment',
    'app.addPostToProject',
    'app.addPostToCampaigns',
    'app.campaignAdvertiserManagePage',
    'app.campaign.campaignForm',
    'app.campaignAdvertiserManagePageAddInfluencers',
    'app.campaignInfluencersManagePage',
    'app.campaignActivity',
    'app.advertiserAddInfluencerToCampaigns',
    'app.campaignViewContract',

    'app.facebookPostOverview'
])

    .service('HttpPendingRequestsService', ['$q',
        function ($q) {
            var cancelPromises = [];
            var totalCountPromises = [];

            function newTimeout(isGetCount) {
                var cancelPromise = $q.defer();
                cancelPromises.push(cancelPromise);

                if (isGetCount) {
                    // Cancel previous requests before sending a new one
                    cancelGetTotalCount(cancelPromise);
                }

                return cancelPromise.promise;
            }

            function cancelAll() {
                angular.forEach(cancelPromises, function (cancelPromise) {
                    cancelPromise.promise.isGloballyCancelled = true;
                    cancelPromise.resolve();
                });
                cancelPromises.length = 0;
            }

            function cancelGetTotalCount(cancelPromise) {
                if (totalCountPromises.length > 0) {
                    for (var i = 0; i < totalCountPromises.length; i++) {
                        totalCountPromises[i].resolve();
                    }
                    totalCountPromises.length = 0;
                }

                totalCountPromises.push(cancelPromise);
            }

            return {
                newTimeout: newTimeout,
                cancelAll: cancelAll,
                cancelGetTotalCount: cancelGetTotalCount
            };
        }])

    .config(['$stateProvider', '$urlRouterProvider', '$httpProvider',
        function ($stateProvider, $urlRouterProvider, $httpProvider) {

            var interceptor = ['$q', '$rootScope', 'localStorageService', 'ipCookie', 'HttpPendingRequestsService', function ($q, $rootScope, localStorageService, ipCookie, HttpPendingRequestsService) {
                var numLoadings = 0;

                return {
                    request: function (config) {
                        if ((config.url.indexOf($rootScope.apiUrl + 'login') < 0 && !ipCookie('access_token_expiration')) &&
                            config.url.indexOf($rootScope.apiUrl) > -1) {
                        }

                        var accessToken = localStorageService.get('access_token');

                        if (accessToken) {
                            config.headers['Authorization'] = accessToken;
                        }

                        if (config.loader != false) {
                            numLoadings++;
                            $rootScope.$broadcast('showLoader', { controller: 'myHttpInterceptor' });
                        }

                        if (config.timeout === undefined && !config.noCancelOnRouteChange) {
                            config.timeout = HttpPendingRequestsService.newTimeout(config.isGetTotalCount);
                        }

                        return config || $q.when(config);
                    },
                    response: function (response) {
                        if (response.config && response.config.loader != false) {
                            numLoadings--;
                        }

                        if (numLoadings <= 0) {
                            $rootScope.$broadcast('hideLoader', { controller: 'myHttpInterceptor' });
                            numLoadings = 0;
                        }

                        if (response.status === 401) {
                        }

                        return response || $q.when(response);
                    },
                    responseError: function (response) {
                        if (response.config && response.config.loader != false) {
                            numLoadings--;
                        }

                        if (numLoadings <= 0) {
                            $rootScope.$broadcast('hideLoader', { controller: 'myHttpInterceptor' });
                            numLoadings = 0;
                        }

                        return $q.reject(response);
                    }
                }
            }];

            $httpProvider.interceptors.push(interceptor);

            $urlRouterProvider.when("", 'login');

            $stateProvider
                .state('landing', {
                    url: '',
                    templateUrl: 'app/layouts/landing.html?app_v=deployDate',
                    resolve: {
                        definitions: function (AuthenticationService) {
                            return AuthenticationService.getDefinitions();
                        }
                    }
                })

                .state('landing.login', {
                    url: '/login?token&redirectToPage',
                    templateUrl: 'app/home/partials/login.html?app_v=deployDate',
                    controller: 'LoginCtrl',
                    data: {
                        authorizedRoles: []
                    }
                })

                .state('landing.emailAuthorize', {
                    url: '/emailAuthorize?token&path',
                    controller: 'AuthorizeByTokenCtrl',
                    data: {
                        authorizedRoles: []
                    }
                })

                .state('landing.authorizeByToken', {
                    url: '/authorizeByToken?token&path&framed',
                    controller: 'AuthorizeByTokenCtrl',
                    data: {
                        authorizedRoles: []
                    }
                })

                .state('landing.welcomeRegister', {
                    url: '/invite/welcome/:hashString',
                    templateUrl: 'app/home/partials/welcomeRegister.html?app_v=deployDate',
                    controller: 'welcomeRegisterCtrl',
                    data: {
                        authorizedRoles: []
                    }
                })
                .state('landing.register', {
                    url: '/register/:param',
                    templateUrl: 'app/home/partials/register.html?app_v=deployDate',
                    controller: 'registerCtrl',
                    data: {
                        authorizedRoles: []
                    }
                })

                .state('landing.welcomeToCampaign', {
                    url: '/welcomeToCampaign?campaignInfluencerId&token',
                    templateUrl: 'app/home/partials/welcomeToCampaign.html?app_v=deployDate',
                    controller: 'WelcomeToCampaignCtrl',
                    controllerAs: 'vm',
                    data: {
                        authorizedRoles: []
                    }
                })

                .state('home', {
                    url: '/',
                    templateUrl: 'app/layouts/site.html?app_v=deployDate',
                    controller: 'HomeCtrl',
                    data: {
                        authorizedRoles: ['Administrator', 'User', 'Achoo Analyst']
                    },
                    resolve: {
                        definitions: function (AuthenticationService) {
                            return AuthenticationService.getDefinitions();
                        }
                    }
                })

            Highcharts.setOptions({
                global: {
                    useUTC: false
                }
            });
        }])

    .config(function (localStorageServiceProvider) {
        localStorageServiceProvider
            .setDefaultToMemory(true);
    })
    .run(['$rootScope', '$http', '$location', '$modal', 'localStorageService', 'AuthenticationService', '$state', 'HttpPendingRequestsService',
        function ($rootScope, $http, $location, $modal, localStorageService, AuthenticationService, $state, HttpPendingRequestsService) {
            $rootScope.apiUrl = window.location.host == 'localhost:9090' ? 'http://localhost:9000/' : '//' + window.location.host + window.location.pathname.replace(/\/$/, '') + '/';

            var currentAppVersion = localStorageService.get('currentAppVersion');
            console.log(currentAppVersion);
            if (currentAppVersion != '?app_v=deployDate') {
                localStorageService.set('currentAppVersion', '?app_v=deployDate');
                AuthenticationService.Logout();
                window.Intercom("shutdown");
            }

            $rootScope.$on('$stateChangeStart', function (event, next) {
                HttpPendingRequestsService.cancelAll();
                if (next && next.data && next.data.authorizedRoles.length > 0 && AuthenticationService.isAuthenticated(next.data.authorizedRoles) === false) {
                    window.location = window.location.pathname.replace(/\/$/, '') + '/#/login';
                }
            });

            $rootScope.handleRequestError = function(err, $scope) {
                if (err) {
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = err.message;
                }
            }
        }])

    .controller('HomeCtrl', ['$scope', '$location', '$modal', '$log', '$rootScope', '$http', '$state', 'AuthenticationService', '$stateParams', '$timeout', '$anchorScroll', '$filter', 'TRACK_EVENTS',
        function ($scope, $location, $modal, $log, $rootScope, $http, $state, AuthenticationService, $stateParams, $timeout, $anchorScroll, $filter, TRACK_EVENTS) {

            $scope.currentUser = $rootScope.currentUser;

            var showChangePwdWarningModal = function () {
                if ($rootScope.currentUser.userStatus && $rootScope.currentUser.userStatus.id === 7 && $state.current.name !== 'home.profileChangePassword') {
                    var modalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/admin/userAndBilling/userManagement/changePasswordWarningModal.html?app_v=deployDate',
                        controller: 'changePasswordWarningModalCtrl as vm'
                    });

                    $scope.modalInstance = modalInstance;
                    $scope.showW = false;
                    modalInstance.result.then(function () {

                    }, function () {

                    });
                }
            };

            showChangePwdWarningModal();

            $rootScope.sideMenuSelections = {
                project: null,
                keyword: null,
                blogs: null,
                channel: null
            };

            $rootScope.selectedPeriod = {
                period: null
            }

            $scope.logout = function () {
                AuthenticationService.Logout();
                window.Intercom("shutdown");
                $location.path('login');
            }

            $rootScope.newMentionModalHandler = function (mention, mentiontype, obligatoryLanguage, callback) {
                mentiontype = mentiontype || null;
                var modalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/common/partials/newMentionModal.html?app_v=deployDate',
                    controller: 'NewMentionCtrl',
                    'data-animation': "am-slide-bottom",
                    resolve: {
                        mention: function () {
                            return mention;
                        },
                        mentiontype: function () {
                            return mentiontype;
                        },
                        language: function () {
                            return obligatoryLanguage;
                        }
                    }
                });

                modalInstance.result.then(function (result) {
                    if (result) {
                        callback(result.newMention)
                    } else {
                        callback(null);
                    }
                }, function () {
                    callback(null);
                });

                $scope.modalInstance = modalInstance;
            }

            $scope.isActiveLocation = function (main, sub) {
                if (typeof ($state.current.data) == 'undefined')
                    return false;

                if (typeof ($state.current.data.navMarker) == 'undefined')
                    return false;

                if (typeof (sub) == 'undefined')
                    return main == $state.current.data.navMarker[0];

                return main == $state.current.data.navMarker[0] && sub == $state.current.data.navMarker[1];
            };

            $scope.checkReload = function (href) {
                if (href.endsWith($state.current.url)) {
                    $state.transitionTo($state.current.name, null, {
                        reload: true,
                        inherit: false,
                        notify: true
                    });
                }
            }

            $scope.$on('showLoader', function (scope, data) {
                $(".main-content").hide();
                $('#loaderDiv').show();
            });

            $scope.$on('hideLoader', function (scope, data) {
                $(".main-content").show();
                $('#loaderDiv').hide();
            });

            $rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams){
                if ($rootScope.currentUser.userStatus && $rootScope.currentUser.userStatus.id === 6 && toState.name !== "landing.login") {
                    var modalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/admin/influencerManagement/registerUserInfoModal.html?app_v=deployDate',
                        controller: 'RegisterUserInfoModalCtrl as vm',
                        windowClass: 'modal-width-525'
                    });

                    $scope.modalInstance = modalInstance;
                    modalInstance.result.then(function () {

                    }, function () {

                    });
                }
            })

            $scope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams){
                $anchorScroll();
                // iframe solution
                if (fromParams.framed && fromParams.framed === 'true') {
                    $scope.isFramed = true;
                    $rootScope.isFramed = true;
                }

                // Mixpanel tracking visit page
                var pages = TRACK_EVENTS.VISIT_PAGE.PAGES;
                for(var i=0; i<pages.length; i++) {
                    if (toState.name === pages[i].STATE) {
                        analytics.track(
                            TRACK_EVENTS.VISIT_PAGE.EVT_NAME,
                            {
                                "item": pages[i].NAME,
                            }
                        );
                        break;
                    }
                }
                if (fromState.name && toState.name === "home.dashboard") {
                    var sideMenu = $rootScope.sideMenuSelectedName;
                    analytics.track(
                        TRACK_EVENTS.VISIT_PAGE.EVT_NAME,
                        {
                            "item": "Home",
                            "target_type": sideMenu && sideMenu.type,
                            "target_name": sideMenu && sideMenu.name,
                            "target_id": sideMenu && sideMenu.id,
                            "sub_target_type": sideMenu && sideMenu.subType,
                            "sub_target_name": sideMenu && sideMenu.subName,
                            "sub_target_id": sideMenu && sideMenu.subId,
                        }
                    );
                }
                if (fromState.name && toState.name === "home.measure") {
                    var sideMenu = $rootScope.sideMenuSelectedName;
                    analytics.track(
                        TRACK_EVENTS.VISIT_PAGE.EVT_NAME,
                        {
                            "item": "Measure",
                            "report_name": $rootScope.selectedReportData && $rootScope.selectedReportData.report_name,
                            "report_id": $rootScope.selectedReportData && $rootScope.selectedReportData.report_id,
                            "target_type": sideMenu && sideMenu.type,
                            "target_name": sideMenu && sideMenu.name,
                            "target_id": sideMenu && sideMenu.id,
                            "sub_target_type": sideMenu && sideMenu.subType,
                            "sub_target_name": sideMenu && sideMenu.subName,
                            "sub_target_id": sideMenu && sideMenu.subId,
                        }
                    );
                }

            })

            $scope.defaultSelect = function () {
                var menuElm = null;
                if ($state.current.url == 'admin/userAndBillingOverview' || $state.current.url == 'admin/userManagement' || $state.current.url == 'admin/systemLog') {
                    menuElm = angular.element('#leftmenu_userbilling');
                }
                if ($state.current.url == 'mention/newMentions' || $state.current.url == 'mention/mentions' || $state.current.url == 'mention/translations' || $state.current.url == 'mention/mentionManagementLog') {
                    menuElm = angular.element('#leftmenu_mention');
                }
                if ($state.current.url == 'admin/status' || $state.current.url == 'admin/newInfluencers' || $state.current.url == 'admin/influencersPending' || $state.current.url == 'admin/influencers' || $state.current.url == 'admin/networks' || $state.current.url == 'admin/influencerManagementLog' || $state.current.url == 'admin/interestingCountry') {
                    menuElm = angular.element('#leftmenu_influencer');
                }
                if ($state.current.url == 'admin/duplicationFactors') {
                    menuElm = angular.element('#leftmenu_duplicationfactors');
                }
                if ($state.current.url == 'admin/referencePoints') {
                    menuElm = angular.element('#leftmenu_referencepoints');
                }
                if ($state.current.url == 'admin/commonPages') {
                    menuElm = angular.element('#leftmenu_commonpages');
                }
                if ($state.current.url == 'admin/manualPosts' || $state.current.url == 'admin/findPost' || $state.current.url == 'admin/reCrawlPosts') {
                    menuElm = angular.element('#leftmenu_post_manual');
                }
                if ($state.current.url == 'admin/engagementScores') {
                    menuElm = angular.element('#leftmenu_engagementscores');
                }
                if ($state.current.url == 'admin/campaignOverview') {
                    menuElm = angular.element('#leftmenu_insight');
                }
                if (menuElm != null) {
                    menuElm.addClass('bg-active');
                    menuElm.find('.parent').addClass('parent-active');
                    menuElm.find('.open-child').show();
                }
            }
            $scope.defaultSelect();

            // left sidebar discover filter (Discover 2.0)
            $scope.discoverFilterRemember = {
                influencers: false,
                projects: false,
                activity: false,
                isPreloadedData: false
            };
            var def = angular.copy($rootScope.definitions);
            var genders = [{name: 'Female', id: 0}, {name: 'Male', id: 1}, {name: 'Online Media', id: 2}];
            var flatforms = def.platforms;
            flatforms[0].icon = '/images/ico/Blogger Logo.png';
            flatforms[1].icon = '/images/ico/Instagram Logo1.png';
            flatforms[2].icon = '/images/ico/Pinterest Logo.png';
            flatforms[3].icon = '/images/ico/snapchat.png';
            flatforms[4].icon = '/images/ico/Twitter Logo.png';
            flatforms[5].icon = '/images/ico/YouTube Logo.png';
            var countries = [];
            angular.forEach(def.countries, function (country) {
                if (country.isActive === 1) {
                    countries.push(country);
                }
            });
            var topics = def.topics;
            var industries = def.verticals;

            var getAllInfluencerGroup = function(selected_company_id) {
                var url_getInfluencerGroups = $rootScope.apiUrl + 'influencerGroup/getInfluencerGroupListSideBarMenu?selected_company_id='+ selected_company_id;
                $http.get(url_getInfluencerGroups, {loader: false}).
                    success(function (response) {
                        var data = response.data;
                        $scope.discoverFilters[3].list = [];
                        angular.forEach(data, function (group) {
                            if (group.visible === 1) {
                                $scope.discoverFilters[3].list.push({id: group.influencer_group_id, name: group.influencer_group_name});
                            }
                        });

                    }).error(function (response) {
                    });
            }

            var registerInfluencerGroupReloadEvent = function () {
                $scope.$on('reload_influencerGroup', function(event, args) {
                    if($rootScope.sideMenuSelections.advertiserId) {
                        getAllInfluencerGroup($rootScope.sideMenuSelections.advertiserId);
                    }
                });
            };

            var getAllProject = function (advertiserId) {
                var url_getAllProject = $rootScope.apiUrl + 'common/getAllProjectByAdvertiserID/' + advertiserId;
                $http.get(url_getAllProject, {loader: false}).
                    success(function (response) {
                        var data = response.data;
                        $scope.discoverFilters[4].list = [];
                        angular.forEach(data, function (prj) {
                            $scope.discoverFilters[4].list.push({id: prj.id, name: prj.name});
                        });
                    }).error(function (response) {
                    });
            };

            var registerProjectReloadEvent = function () {
                $scope.$on('reload_advertiserProjectList', function (event, args) {
                    if($rootScope.sideMenuSelections.advertiserId) {
                        getAllProject($rootScope.sideMenuSelections.advertiserId);
                    }
                })
            };

            $scope.discoverFilters = [
                {
                    heading: 'countries',
                    type: 1,
                    open: false,
                    list: countries,
                },
                {
                    heading: 'genders',
                    type: 2,
                    open: false,
                    list: genders,
                },
                {
                    heading: 'Platforms',
                    type: 3,
                    open: false,
                    list: flatforms,
                },
                {
                    heading: 'influencers',
                    type: 4,
                    open: false,
                    list: [],
                },
                {
                    heading: 'projects',
                    type: 5,
                    open: false,
                    list: [],
                },
                {
                    heading: 'topics',
                    type: 6,
                    open: false,
                    list: topics,
                },
                {
                    heading: 'industries',
                    type: 7,
                    open: false,
                    list: industries,
                },
                {
                    heading: 'activity',
                    type: 8,
                    open: false,
                    list: {
                        reach: undefined,
                        engagement: undefined,
                        impact: undefined,
                    }
                }
            ];

            function declareSlider () {
                $scope.monthlyReachSlider = $("#monthlyReachSliderB").bootstrapSlider({
                    range: true,
                    min: 0,
                    max: 1000000,
                    tooltip: 'always',
                    tooltip_split: true,
                    formatter: function (n) {
                        if(n == 1000000) {
                            return $filter('number')(n, 0) + '+';
                        } else {
                            return $filter('number')(n, 0)
                        }
                    }
                });

                $scope.avgEngagementsPerPostSlider = $("#avgEngagementsPerPostSliderB").bootstrapSlider({
                    range: true,
                    min: 0,
                    max: 1000000,
                    tooltip: 'always',
                    tooltip_split: true,
                    formatter: function (n) {
                        if(n == 1000000) {
                            return $filter('number')(n, 0) + '+';
                        } else {
                            return $filter('number')(n, 0)
                        }
                    }
                });

                $scope.avgImpactSlider = $("#avgImpactSliderB").bootstrapSlider({
                    range: true,
                    min: 0,
                    max: 300,
                    tooltip: 'always',
                    tooltip_split: true,
                    formatter: function (n) {
                        if(n == 300) {
                            return $filter('number')(n, 0) + '%+';
                        } else {
                            return $filter('number')(n, 0) + '%';
                        }
                    }
                });
            }

            $scope.$watch('discoverFilters[7].open', function(isOpen){
                if (isOpen && !$scope.discoverFilterRemember.activity) {
                    declareSlider();
                    $scope.discoverFilterRemember.activity = true;
                }
            });

            $scope.$watch('discoverFilters[3].open', function(isOpen){
                if ($scope.discoverFilters[3].list.length === 0) {
                    $scope.discoverFilterRemember.influencers = false;
                }
                if (isOpen && !$scope.discoverFilterRemember.influencers) {
                    getAllInfluencerGroup($rootScope.sideMenuSelections.advertiserId);
                    registerInfluencerGroupReloadEvent();
                    $scope.discoverFilterRemember.influencers = true;
                }
            });

            $scope.$watch('discoverFilters[4].open', function(isOpen){
                if ($scope.discoverFilters[4].list.length === 0) {
                    $scope.discoverFilterRemember.projects = false;
                }
                if (isOpen && !$scope.discoverFilterRemember.projects) {
                    getAllProject($rootScope.sideMenuSelections.advertiserId);
                    registerProjectReloadEvent();
                    $scope.discoverFilterRemember.projects = true;
                }
            });

            // re-load project list for Discover
            var preloadDiscoverSidebarData = function () {
                getAllProject($rootScope.sideMenuSelections.advertiserId);
                $scope.discoverFilterRemember.projects = true;
                registerProjectReloadEvent();

                getAllInfluencerGroup($rootScope.sideMenuSelections.advertiserId);
                registerInfluencerGroupReloadEvent();
                $scope.discoverFilterRemember.influencers = true;

                $scope.discoverFilterRemember.isPreloadedData = true;
            }

            $scope.$watch('sideMenuSelections.advertiserId', function(newValue, oldVaule){
                if (!$scope.discoverFilterRemember.isPreloadedData && newValue && newValue !== oldVaule) {
                    preloadDiscoverSidebarData();
                }
            });

            $scope.$watch('discoverFilters', function(discoverFilters){
                if (discoverFilters) {
                    $rootScope.$broadcast('discoverFilterChanging', { filters: discoverFilters });
                }
            }, true);

            /*$scope.$watch('discoverActivityAcc.list', function(activityFilter){
                if (activityFilter) {
                    $rootScope.$broadcast('discoverActivityFilterChanging', { activityFilter: activityFilter });
                }
            }, true);*/

            var inactiveParam = function (param) {
                if (param.type === 8) {
                    if (param.activityType === 1) {
                        $scope.discoverFilters[7].list.reach = undefined;
                        $scope.monthlyReachSlider.bootstrapSlider('setValue', [0, 1000000]);
                    }
                    if (param.activityType === 2) {
                        $scope.discoverFilters[7].list.engagement = undefined;
                        $scope.avgEngagementsPerPostSlider.bootstrapSlider('setValue', [0, 1000000]);
                    }
                    if (param.activityType === 3) {
                        $scope.discoverFilters[7].list.impact = undefined;
                        $scope.avgImpactSlider.bootstrapSlider('setValue', [0, 300]);
                    }
                }
                else {
                    for (var i=0; i < $scope.discoverFilters.length; i++) {
                        if ($scope.discoverFilters[i].type === param.type ) {
                            var list = $scope.discoverFilters[i].list;
                            for (var j=0; j < list.length; j++) {
                                if (list[j].id === param.id) {
                                    list[j].value = false;
                                    console.log(list[j]);
                                    break;
                                }
                            }
                        }
                    }
                }
            };

            $scope.$on('discoverActiveParamChanging', function (scope, data) {
                console.log('discoverActiveParamChanging');
                inactiveParam(data.param);
            });

            var clearAllFilters = function () {
                $scope.discoverFilters[7].list.reach = undefined;
                $scope.discoverFilters[7].list.engagement = undefined;
                $scope.discoverFilters[7].list.impact = undefined;
                if ($scope.monthlyReachSlider) {
                    $scope.monthlyReachSlider.bootstrapSlider('setValue', [0, 1000000]);
                    $scope.avgEngagementsPerPostSlider.bootstrapSlider('setValue', [0, 1000000]);
                    $scope.avgImpactSlider.bootstrapSlider('setValue', [0, 300]);
                }

                for (var i=0; i < $scope.discoverFilters.length; i++) {
                    var list = $scope.discoverFilters[i].list;
                    for (var j=0; j < list.length; j++) {
                        list[j].value = false;
                    }
                }
            };
            $scope.$on('discoverActiveParamClear', function () {
                console.log('discoverActiveParamClear');
                clearAllFilters();
            });


            var handleInfluencersFilter = function (filters) {
                var isHas = false;
                for (var i=0; i<filters.list.length; i++) {
                    if (filters.list[i].value) {
                        isHas = true;
                        break;
                    }
                }
                if (isHas) {
                    $scope.discoverFilterRemember.influencers = true;
                    registerInfluencerGroupReloadEvent();
                }
            };

            var handleProjectsFilter = function (filters) {
                var isHas = false;
                for (var i=0; i<filters.list.length; i++) {
                    if (filters.list[i].value) {
                        isHas = true;
                        break;
                    }
                }
                if (isHas) {
                    $scope.discoverFilterRemember.projects = true;
                    registerProjectReloadEvent();
                }
            };

            var handleActivityFilter = function (filters) {
                if (filters.list.reach || filters.engagement || filters.impact) {
                    declareSlider();
                    $scope.discoverFilterRemember.activity = true;
                    if (filters.list.reach) {
                        var value = filters.list.reach.split(',');
                        $scope.monthlyReachSlider.bootstrapSlider('setValue', [Number(value[0]), Number(value[1])]);
                    }
                    if (filters.list.engagement) {
                        var value = filters.list.engagement.split(',');
                        $scope.avgEngagementsPerPostSlider.bootstrapSlider('setValue', [Number(value[0]), Number(value[1])]);
                    }
                    if (filters.list.impact) {
                        var value = filters.list.impact.split(',');
                        $scope.avgImpactSlider.bootstrapSlider('setValue', [Number(value[0]), Number(value[1])]);
                    }
                }
            };

            $scope.$on('discoverReSearchFilterChanging', function (scope, data) {
                console.log('discoverReSearchFilterChanging');
                var currentProjList = angular.copy($scope.discoverFilters[4]);
                var isTheSameProjectList = angular.equals(currentProjList.list, data.filters[4].list);
                var currentInfGroupList = angular.copy($scope.discoverFilters[3]);
                var isTheSameInfGroupList = angular.equals(currentInfGroupList.list, data.filters[3].list);
                $scope.discoverFilters = data.filters;
                if (!isTheSameProjectList) {
                    $scope.discoverFilters[4] = currentProjList;
                }
                if (!isTheSameInfGroupList) {
                    $scope.discoverFilters[3] = currentInfGroupList;
                }
                handleInfluencersFilter($scope.discoverFilters[3]);
                handleProjectsFilter($scope.discoverFilters[4]);
                handleActivityFilter($scope.discoverFilters[7]);

            });

            var mapActiveParamIntoFilter = function (i, id) {
                var list = $scope.discoverFilters[i].list;
                for (var j=0; j < list.length; j++) {
                    if (list[j].id === id) {
                        list[j].value = true;
                        break;
                    }
                }
            };

            var getInfluencerGroupListSideBarMenu = function (id) {
                return discoverService.searchDiscoverInfluencer(id, false)
                    .then(function(response){
                        return response;
                    },
                    function (){
                        return false;
                    });
            }

            $scope.$on('discoverUsingAvailableParams', function (scope, data) {
                console.log('discoverUsingAvailableParams');
                clearAllFilters();
                var params = data.activeParams;
                var typeArray = [1,2,3,6,7];
                for (var i=0; i<params.length; i++) {
                    if (typeArray.indexOf(params[i].type) !== -1) {
                        mapActiveParamIntoFilter(params[i].type-1, params[i].id);
                    }
                    if (params[i].type === 4) {
                        var isExisted = false;
                        for (var j=0; j<$scope.discoverFilters[3].list.length; j++) {
                            if ($scope.discoverFilters[3].list[j].id === params[i].id) {
                                $scope.discoverFilters[3].list[j].value = true;
                                isExisted = true;
                                break;
                            }
                        }
                        if (!isExisted) {
                            $scope.discoverFilters[3].list.push({id: params[i].id, name: params[i].name, value: true});
                        }
                        $scope.discoverFilterRemember.influencers = true;
                        registerInfluencerGroupReloadEvent();
                    }
                    if (params[i].type === 5) {
                        var isExisted = false;
                        for (var k=0; k<$scope.discoverFilters[4].list.length; k++) {
                            if ($scope.discoverFilters[4].list[k].id === params[i].id) {
                                $scope.discoverFilters[4].list[k].value = true;
                                isExisted = true;
                                break;
                            }
                        }
                        if (!isExisted) {
                            $scope.discoverFilters[4].list.push({id: params[i].id, name: params[i].name, value: true});
                        }
                        $scope.discoverFilterRemember.projects = true;
                        registerProjectReloadEvent();
                    }
                    if (params[i].type === 8) {
                        if (!$scope.monthlyReachSlider) {
                            declareSlider();
                            $scope.discoverFilterRemember.activity = true;
                        }
                        var value = params[i].id.split(',');
                        if (params[i].activityType === 1) {
                            $scope.discoverFilters[7].list.reach = params[i].id;
                            $scope.monthlyReachSlider.bootstrapSlider('setValue', [Number(value[0]), Number(value[1])]);
                        }
                        if (params[i].activityType === 2) {
                            $scope.discoverFilters[7].list.engagement = params[i].id;
                            $scope.avgEngagementsPerPostSlider.bootstrapSlider('setValue', [Number(value[0]), Number(value[1])]);
                        }
                        if (params[i].activityType === 3) {
                            $scope.discoverFilters[7].list.impact = params[i].id;
                            $scope.avgImpactSlider.bootstrapSlider('setValue', [Number(value[0]), Number(value[1])]);
                        }
                    }
                }
            });

            // end


        }])

    .controller('HotKeyPrintCtrl', ['$scope', '$rootScope', '$anchorScroll', '$window',
        function ($scope, $rootScope, $anchorScroll, $window) {
            var isCtrlHold = false;

            var printPdf = function () {
                $rootScope.$broadcast('beforePrint');
            }

            $scope.keyDown = function (event) {
                if (event.keyCode == 17) {
                    isCtrlHold = true;
                }

                if (isCtrlHold) {
                    if (event.keyCode == 80) {
                        event.preventDefault();
                        event.stopPropagation();
                        printPdf();
                    }
                }
            }

            $scope.keyUp = function (event) {
                if (event.keyCode == 17) {
                    isCtrlHold = false;
                }
            }

            var beforePrint = function () {
                $anchorScroll('#topAnchor');
                $('body').addClass('zoom-reset');
                setTimeout(afterPrint, 10);
            }

            var afterPrint = function () {
                $('body').removeClass('zoom-reset');
            }

            if ($window.matchMedia) {
                var mediaQueryList = $window.matchMedia('print');
                mediaQueryList.addListener(function (mql) {
                    if (mql.matches) {
                        beforePrint();
                    }
                });
            }

            $scope.$on('printPdf', function () {
                printPdf();
            })
        }])
